import { FaturaTipleri } from '@core/genel/AppEnums';

export class AktifFaturaBilgisi {
    FATURA_TIPI_ID: FaturaTipleri;
}